export default __webpack_public_path__ + "static/media/homeBijoux4.b2a2e215.jpg";